module.exports = __webpack_public_path__ + "img/small-logo.004f89e0.svg";